import React from "react";
import { Trans } from "@lingui/macro";

export function getListItemsTitle(inputString) {
    const firstWordCaptialisedString = inputString.charAt(0).toUpperCase() + inputString.slice(1);
    const result = firstWordCaptialisedString.split('_').join(' ');
    return `${result}:`;
}

export const processInvalidListItems = (arrOfInvalids, title) => {
    if (arrOfInvalids?.length && arrOfInvalids.length !== 0) {
        return [(
            <span>
                {title}
                {' '}
                { arrOfInvalids.map((item, idx) => (
                    <span key={Math.random()}>
                        {item}
                        {idx === arrOfInvalids.length - 1 ? null : (
                            <span>
                                ,
                                {' '}
                            </span>)}
                    </span>
                ))}
            </span>
        )];
    }
    return [];
};

export const renderBasicSecondaryListItem = arr => (
    <ul className="ul__circle secondary">
        {arr.map(item => <li key={Math.random()}>{item}</li>)}
    </ul>
);

export const renderSecondaryListItemWithItem = (arr, renderItemFn) => (
    <ul className="ul__circle secondary">
        {arr.map(item => (
            <li key={Math.random()}>
                {`${item.number}: `}
                {renderItemFn(item)}
            </li>
        ),
        )}
    </ul>);

export const renderTableItemsChanges = (itemsChangesArr, title) => (
    <div key={Math.random()}>
        <strong>
            {title}
        </strong>
        <ul className="ul__disc">
            {itemsChangesArr.length !== 0 ? (
                <li key={Math.random()}>
                    <Trans>
                        <strong>
                            Lines with the following items will be removed:
                        </strong>
                    </Trans>
                    {renderBasicSecondaryListItem(itemsChangesArr)}
                </li>) : null}
        </ul>
        <br />
    </div>
);
